import { useFormContext } from "react-hook-form";
import { styled } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faLocationDot } from "@fortawesome/free-solid-svg-icons";

import OutletCard from "./mocks/OutletCard";
import OrderCard from "./mocks/OrderCard";
import { FontVariant } from "../../constants/fonts";
import { ThemeFormValuesType } from "../../forms/app/ThemeForm";

const Container = styled.div`
  height: 836px;
  width: 393px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const TopBar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 2px 20px rgba(0, 98, 103, 0.1);
  padding: 20px;
`;

const CircleButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
`;

const ContentContainer = styled.div`
  padding: 20px;
  width: 100%;
`;

const SectionTitle = styled.div`
  text-align: start;
`;

const LocationButton = styled(CircleButton)`
  width: 120px;
  font-size: 14px;
  border-radius: 60px;
`;

export default function TertiaryThemePreview() {
  const { watch } = useFormContext<ThemeFormValuesType>();
  const values = watch();
  const { tertiary, secondary, primary, isWL } = values;
  const {
    color: PrimaryColor,
    content: PrimaryContent,
    buttons: PrimaryButtons,
  } = primary;
  const { color: SecondaryColor, content: SecondaryContent } = secondary;
  const { color: TertiaryColor, content } = tertiary;
  const { default: DefaultContentColor } = content;
  const { default: DefaultPrimaryButton } = PrimaryButtons;

  return (
    <Container style={{ backgroundColor: TertiaryColor }}>
      <TopBar
        style={{
          backgroundColor: isWL ? TertiaryColor : SecondaryColor,
        }}
      >
        <LocationButton
          style={{
            backgroundColor: isWL ? DefaultPrimaryButton.color : PrimaryColor,
            color: isWL ? DefaultContentColor : PrimaryContent.default,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          <FontAwesomeIcon
            style={{ marginRight: 10 }}
            icon={faLocationDot}
            color={isWL ? DefaultContentColor : SecondaryContent.alt_1}
          />
          Stockholm
        </LocationButton>
        <CircleButton
          style={{
            backgroundColor: "transparent",
          }}
        >
          <FontAwesomeIcon
            icon={faBars}
            color={isWL ? SecondaryColor : SecondaryContent.alt_1}
          />
        </CircleButton>
      </TopBar>
      <ContentContainer>
        <SectionTitle
          style={{
            color: DefaultContentColor,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          Select restaurant
        </SectionTitle>
        <OutletCard />
        <SectionTitle
          style={{
            marginTop: 20,
            color: DefaultContentColor,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          Previous Orders
        </SectionTitle>
        <OrderCard success />
        <OrderCard success={false} />
      </ContentContainer>
    </Container>
  );
}
